module.exports = __webpack_public_path__ + "img/company_img.9a0f0adf.png";